import { ErrorHandler, Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LoggerService } from './services/logger.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private messageService = inject(MessageService);
  private logger = inject(LoggerService);

  handleError(error: unknown): void {
    this.logger.error('Unhandled error:', error);

    try {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'An unexpected error occurred',
        life: 5000,
      });
    } catch {
      // Prevent recursive error handling if toast itself fails
    }
  }
}
